import { PATH_APP_DOWNLOAD } from './constants/paths';

const PUBLIC_STANDALONE_PATHS = new Set([PATH_APP_DOWNLOAD]);

const normalizePathname = (pathname = '') => {
  if (pathname === '/') return pathname;

  return pathname.replace(/\/+$/, '');
};

export const isPublicStandalonePath = (pathname) => {
  return PUBLIC_STANDALONE_PATHS.has(normalizePathname(pathname));
};
